import keyMirror from 'react-utils/keyMirror';
export const SCOPE_VERSIONS = keyMirror({
  LEGACY: 'LEGACY',
  GRANULAR: 'GRANULAR'
});
export const SCOPE_VERSIONS_LIST = [SCOPE_VERSIONS.LEGACY, SCOPE_VERSIONS.GRANULAR];